import MJSONScreenshot from '@admin/components/mjson_screenshot'
import Date from '@admin/components/date'
import PropTypes from 'prop-types'
import React from 'react'

const getScreenshot = (entity) => ({
  engine: 'mjson',
  entity: `campaigns_social_campaign_variants/${entity.code}`,
  width: 100,
  height: 75,
  screenshoted_at: entity.screenshoted_at
})

const SocialCampaignToken = ({ social_campaign }) => (
  <div className="campaign-token">
    <div className="campaign-token-preview">
      <div className="campaign-token-preview-inner">
        <MJSONScreenshot { ...getScreenshot(social_campaign.variants[0]) } />
      </div>
    </div>
    <div className="campaign-token-label">
      <div className="token-link">
        { social_campaign.type.toUpperCase() }: { social_campaign.title }<br />
      </div>
      <div className="token-stats">
        { social_campaign.team.title }
      </div>
      <div className="token-stats">
        <span className={ social_campaign.status }>{ social_campaign.status }</span>
        <span><Date datetime={ social_campaign.posted_at } /></span>
      </div>
    </div>
  </div>
)

SocialCampaignToken.propTypes = {
  social_campaign: PropTypes.object
}

export default SocialCampaignToken
